import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import request from '@/modules/base/util/request'
import { makeStyles } from '@mui/styles'
import settingsConfig from '@/modules/settings/config'
import lang from '@/lang'
import TextBlock from '@/modules/base/components/texts/text-block'
import Header from '@/modules/letter/components/header/header'
import LetterModel from '@/modules/letter/model/letter_model'

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    width: '100%',
  },
  wrapper: {
    width: '100%',
    '& .headerWrapper': {
      '& .headerContainer ': {
        height: 180,
      },
    },
  },
}))

const LogoUpload = forwardRef((props, ref) => {
  const { isHeaderEdit, showDescription = true, showSaveButton = true } = props
  const classes = useStyles()
  const [letterPaperElements, setLetterPaperElements] = useState()
  const headerRef = useRef()
  useImperativeHandle(ref, () => ({
    save: async() => {
      if (headerRef.current) {
        return headerRef.current.save()
      }
    },
  }))

  useEffect(() => {
    request(settingsConfig.getLetterPaper, {
      method: 'GET',
      auth: true,
      isConcurrent: true,
    })
      .then((result) => {
        const { body: { data } } = result
        setLetterPaperElements(new LetterModel(data))
      })
  }, [])

  return (
    <div>
      <TextBlock>{showDescription && lang.settings.letterPaperSettings.descriptions.header}</TextBlock>
      <div className={classes.content}>
        <div className={classes.wrapper}>
          {letterPaperElements
          && <Header isHeaderEdit={isHeaderEdit} ref={headerRef} showSaveButton={showSaveButton}
            items={letterPaperElements?.header?.models || []}
            collection={letterPaperElements?.header}
            model={{ letterElements: letterPaperElements }} />}
        </div>
      </div>
    </div>
  )
})

LogoUpload.propTypes = {
  isHeaderEdit: PropTypes.bool,
  showDescription: PropTypes.bool,
}

export default LogoUpload
